<template>
  <div class="word-container">
    <div class="word-and-btn">
      <span class="word">{{word.wordName}}</span>
    </div>
    <div v-if="word && !word.word.wordId" class="no-word-desc">不好意,该单词未收录~</div>
    <div class="pronounce-wrapper" v-else>
      <div v-if="word.word.ukSpeech" class="pronounce-btn"
           :class="{'pronounce-btn-sel': word.word.ukSpeech && word.word.ukSpeech == curAudioUrl}"
           @click="_actionPlayAudio(word.word.ukSpeech)">
        英: {{word.word.ukPhonetic}}
        <van-icon class="icon" name="volume-o"/>
      </div>
      <div v-if="word.word.usSpeech" class="pronounce-btn"
           :class="{'pronounce-btn-sel': word.word.usSpeech && word.word.usSpeech == curAudioUrl}"
           @click="_actionPlayAudio(word.word.usSpeech)">
        美: {{word.word.usPhonetic}}
        <van-icon class="icon" name="volume-o"/>
      </div>
      <audio
        ref="audioPlayer"
        :src="curAudioUrl"
        @ended="audioEnd"
      ></audio>
    </div>
    <div class="word-explain">{{explainWord}}</div>

    <template v-if="richSectence">
      <p class="sentence-title">文中的句子</p>
      <p class="rich-sentence">{{richSectence.replace(/&nbsp;/g, ' ')}}</p>
    </template>

    <van-button color="#fff" class="action-see" plain type="info" @click="action_see()">我会了,下一个</van-button>

<!--    <van-button v-if="showShengci && word.wordId" class="new-word-btn" :class="{'sel-new-word-btn': isAddToNewWord}"-->
<!--                plain round type="info"-->
<!--                @click="action_newword()">{{btnword}}-->
<!--    </van-button>-->
  </div>
</template>

<script>
  import {postRemoveWord} from "../../../../api/vocab";

  export default {
    props: {
      word: {
        type: Object,
        default: {}
      }
    },
    name: "ShengCi",
    data() {
      return {
        curAudioUrl: '',
      }
    },

    computed: {
      explainWord() {
        if (this.word.explainCn){
           return this.word.explainCn
        }
        let wordExplain = ''
        this.word.word.explains && this.word.word.explains.forEach(item => {
          wordExplain = `${wordExplain}${item}\n`
        })
        return wordExplain;
      },

      richSectence() {
        return this.word.sentence;
      }
    },
    methods: {
      //点击发音
      _actionPlayAudio(audioUrl) {
        if (this.curAudioUrl == audioUrl) {
          return
        }
        let _Player = this.$refs.audioPlayer;
        _Player.pause();
        this.curAudioUrl = audioUrl;
        setTimeout(() => {
          _Player.play();
        }, 200)
      },

      //点击我会了,下一个
      async action_see(){
        this.$loading.show()
        //1.删除当前单词
        await this.request_postRemoveWord()
        this.$loading.hide()
        console.log('==========2')
        //2.刷新当前列表
        this.$emit('refreshWord')
      },

      //============net==============
      //删除单词
      request_postRemoveWord() {
        return postRemoveWord(this.word.userNewWordId).then(result => {
          console.log('==========1')
          if (result.code === 0) {
            return Promise.resolve()
          } else {
            this.$toast(result.msg)
            return Promise.reject()
          }
        })
      },

      //=========audio==========
      audioEnd() {
        this.curAudioUrl = ''
      },
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .word {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }
  .pronounce-wrapper {
    display: flex;

    .pronounce-btn {
      margin-right: 12px;
      color: #999;
      display: flex;
      align-items: center;
      .icon{
        margin-left: 6px;
      }
    }

    .pronounce-btn-sel {
      color: red;
    }
  }

  .word-explain {
    margin-top: 8px;
    white-space: pre-line;
  }

  .sentence-title{
    margin-top: 20px;
    font-size: 13px;
    color: #333;
  }

  .rich-sentence{
    margin-top: 4px;
    font-size: 12px;
    color: #666;
  }

  .action-see{
    margin-top: 20px;
    background-image: linear-gradient(to right, #3994E7, #98CEFF);
    color: #fff;
    width: 100%;
    border-radius: 50px;
  }
</style>



// WEBPACK FOOTER //
// app/pages/tabs/Mine/components/ShengCi.vue